import systemConfigurationService from '../services/system-configuration.service';
import {CountryDto, SystemConfigurationDto} from 'src/dtos/system-configuration.dto';
import {getCountriesMapByStringKey} from './nestedSearchUtil';

export class SystemConfiguration {
    private static instance: SystemConfiguration;
    public data: SystemConfigurationDto;
    public isLoading = false;
    public hasLoaded = false;
    private countryDtoMapIncludeHidden: Record<string, CountryDto[]> = {};
    private constructor() {
        this.data = {} as SystemConfigurationDto;
    }
    public static getInstance(): SystemConfiguration {
        if (!SystemConfiguration.instance) {
            SystemConfiguration.instance = new SystemConfiguration();
        }
        return SystemConfiguration.instance;
    }

    get countryDtoMap() {
        return this.data.countryDtoMap;
    }

    get getCountryDtoMapIncludeHidden() {
        return this.countryDtoMapIncludeHidden;
    }

    get policyGeneratorAnalysisDays() {
        return this.data.policyGeneratorAnalysisDays;
    }

    get getCountriesMapByCode(): { [key: string]: CountryDto } {
        return getCountriesMapByStringKey(this.countryDtoMap, 'countryCode');
    }

    get getCountriesMapByName(): { [key: string]: CountryDto } {
        return getCountriesMapByStringKey(this.countryDtoMap, 'countryName');
    }

    get getCountriesMapByOfficialName(): { [key: string]: CountryDto } {
        return getCountriesMapByStringKey(this.countryDtoMap, 'countryOfficialName');
    }

    get getCountriesMapByOfficialNameIncludeHidden(): { [key: string]: CountryDto } {
        return getCountriesMapByStringKey(this.getCountryDtoMapIncludeHidden, 'countryOfficialName');
    }

    get categoryDtoList() {
        return (this.data.categoryDtoList || []).filter(category => category.categorySource === 'NB');
    }

    get abfBronzeCategoryDtoList() {
        return (this.data.categoryDtoList || [])
            .filter(category => category.categorySource === 'B')
            .sort((a, b) => a.categoryTitle.localeCompare(b.categoryTitle));
    }

    get defaultServiceDtoList() {
        return this.data.defaultServiceDtoList || [];
    }

    get saneDoNoDeleteAddressName() {
        return this.data.fwPropertiesMap['SANE_DO_NOT_DELETE'];
    }

    get specialCustomServicesNamesDtoList() {
        return this.data.generalCustomServicesNameList;
    }

    get releaseVersion() {
        return this.data.releaseVersion || '2.0';
    }

    get delayBetweenPopups() {
        return this.data.delayBetweenPopups || 3;
    }

    get maxBulkPolicyUpdate() {
        return this.data.maxBulkPolicyUpdate || 10;
    }

    get editApplyPolicyTimeBeforeSchedule() {
        return this.data.editApplyPolicyTimeBeforeSchedule || 10;
    }

    get maxDomainsCount() {
        return this.data.maxDomainsCount;
    }

    public async load() {
        this.isLoading = true;
        const res = await systemConfigurationService.getSystemConfiguration();
        if (!res.ruleNameByAlias || !res.fwPropertiesMap) {
            throw new Error('ruleNameByAlias or fwPropertiesMap not defined.');
        }
        this.data = res;
        this.countryDtoMapIncludeHidden = this.data.countryDtoMap;
        this.data.countryDtoMap = Object.fromEntries(
            Object.entries(this.data.countryDtoMap).map(([key, countries]) => [
                key,
                countries.filter(country => !country.hiddenCountry)
            ])
        );
        this.isLoading = false;
        this.hasLoaded = true;
    }
}